import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

function Payslips({ user }) {
  const [payslips, setPayslips] = useState([]);
  const [connection, setConnection] = useState(null);
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [showConnectForm, setShowConnectForm] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [loading, setLoading] = useState(true);

  const [connectData, setConnectData] = useState({
    silae_employee_id: '',
    silae_username: '',
    auto_sync: true
  });

  useEffect(() => {
    fetchConnection();
    fetchPayslips();
  }, []);

  const fetchConnection = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/silae/connection', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setConnection(response.data);
    } catch (error) {
      console.error('Erreur connexion Silae:', error);
    }
  };

  const fetchPayslips = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/silae/payslips', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPayslips(response.data);
    } catch (error) {
      console.error('Erreur bulletins:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleConnect = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/silae/connect', connectData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Connexion Silae établie avec succès!');
      setShowConnectForm(false);
      fetchConnection();

      // Synchroniser immédiatement
      handleSync();
    } catch (error) {
      console.error('Erreur connexion:', error);
      alert('Erreur lors de la connexion Silae.');
    }
  };

  const handleSync = async () => {
    try {
      setSyncing(true);
      const token = localStorage.getItem('token');
      await axios.post('/api/silae/sync', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Synchronisation réussie!');
      fetchPayslips();
      fetchConnection();
    } catch (error) {
      console.error('Erreur sync:', error);
      alert('Erreur lors de la synchronisation.');
    } finally {
      setSyncing(false);
    }
  };

  const handleDisconnect = async () => {
    if (!window.confirm('Déconnecter votre compte Silae ?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/silae/disconnect', {}, {
        headers: { Authorization: `Bearer ${token}` }
      });

      alert('Compte Silae déconnecté.');
      fetchConnection();
      setPayslips([]);
    } catch (error) {
      console.error('Erreur déconnexion:', error);
      alert('Erreur lors de la déconnexion.');
    }
  };

  const getMonthLabel = (monthStr) => {
    const [year, month] = monthStr.split('-');
    const months = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
    return `${months[parseInt(month) - 1]} ${year}`;
  };

  if (loading) {
    return (
      <div className="container">
        <div className="loading">Chargement des bulletins...</div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <h2 style={{ margin: 0 }}>💰 Bulletins de Paie</h2>
          {connection?.is_connected ? (
            <div style={{ display: 'flex', gap: '1rem' }}>
              <button
                onClick={handleSync}
                disabled={syncing}
                style={{
                  padding: '0.7rem 1.5rem',
                  background: syncing ? '#95a5a6' : '#B8472E',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: syncing ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold'
                }}
              >
                {syncing ? '🔄 Synchronisation...' : '🔄 Synchroniser'}
              </button>
              <button
                onClick={handleDisconnect}
                style={{
                  padding: '0.7rem 1.5rem',
                  background: '#e74c3c',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              >
                Déconnecter Silae
              </button>
            </div>
          ) : (
            <button
              onClick={() => setShowConnectForm(true)}
              style={{
                padding: '0.7rem 1.5rem',
                background: '#27ae60',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              🔗 Connecter Silae
            </button>
          )}
        </div>

        {/* Statut connexion */}
        {connection && (
          <div style={{
            background: connection.is_connected ? '#d4edda' : '#fff3cd',
            border: `2px solid ${connection.is_connected ? '#2F7D5B' : '#B9831C'}`,
            borderRadius: '8px',
            padding: '1rem',
            marginBottom: '2rem'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <span style={{ fontSize: '2rem' }}>{connection.is_connected ? '✅' : '⚠️'}</span>
              <div>
                <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                  {connection.is_connected ? 'Compte Silae connecté' : 'Compte Silae non connecté'}
                </div>
                {connection.last_sync && (
                  <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '0.3rem' }}>
                    Dernière synchronisation: {format(new Date(connection.last_sync), 'dd/MM/yyyy à HH:mm')}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Formulaire de connexion */}
        {showConnectForm && (
          <div style={{ background: '#f8f9fa', padding: '2rem', borderRadius: '12px', marginBottom: '2rem' }}>
            <h3 style={{ marginBottom: '1.5rem' }}>Connecter votre compte Silae</h3>
            <p style={{ color: '#666', marginBottom: '1.5rem' }}>
              Cette fonctionnalité simule l'intégration avec Silae. En production, elle utiliserait l'API officielle Silae via OAuth.
            </p>
            <form onSubmit={handleConnect}>
              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Identifiant employé Silae
                </label>
                <input
                  type="text"
                  value={connectData.silae_employee_id}
                  onChange={(e) => setConnectData({ ...connectData, silae_employee_id: e.target.value })}
                  required
                  placeholder="Ex: EMP12345"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  Nom d'utilisateur Silae
                </label>
                <input
                  type="text"
                  value={connectData.silae_username}
                  onChange={(e) => setConnectData({ ...connectData, silae_username: e.target.value })}
                  required
                  placeholder="Ex: jean.dupont@email.com"
                  style={{ width: '100%', padding: '0.7rem', borderRadius: '6px', border: '1px solid #ddd' }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <input
                    type="checkbox"
                    checked={connectData.auto_sync}
                    onChange={(e) => setConnectData({ ...connectData, auto_sync: e.target.checked })}
                  />
                  <span>Synchronisation automatique mensuelle</span>
                </label>
              </div>

              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  type="submit"
                  style={{
                    padding: '0.7rem 1.5rem',
                    background: '#27ae60',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontWeight: 'bold'
                  }}
                >
                  🔗 Connecter
                </button>
                <button
                  type="button"
                  onClick={() => setShowConnectForm(false)}
                  style={{
                    padding: '0.7rem 1.5rem',
                    background: '#95a5a6',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  Annuler
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Liste des bulletins */}
        {!connection?.is_connected ? (
          <div style={{ textAlign: 'center', padding: '4rem', color: '#999' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>💰</div>
            <p style={{ fontSize: '1.2rem', marginBottom: '0.5rem' }}>
              Connectez votre compte Silae pour accéder à vos bulletins de paie
            </p>
            <p style={{ fontSize: '0.9rem' }}>
              Consultez vos bulletins directement depuis RZT App
            </p>
          </div>
        ) : payslips.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '4rem', color: '#999' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📄</div>
            <p>Aucun bulletin disponible</p>
            <button
              onClick={handleSync}
              style={{
                marginTop: '1rem',
                padding: '0.7rem 1.5rem',
                background: '#B8472E',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              🔄 Synchroniser maintenant
            </button>
          </div>
        ) : (
          <div>
            <h3 style={{ marginBottom: '1.5rem', fontSize: '1.3rem' }}>📋 Historique des bulletins</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))', gap: '1.5rem' }}>
              {payslips.map(payslip => (
                <div
                  key={payslip.id}
                  onClick={() => setSelectedPayslip(payslip)}
                  style={{
                    padding: '1.5rem',
                    background: 'linear-gradient(135deg, #B8472E 0%, #6E2A19 100%)',
                    color: 'white',
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
                  onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  <h3 style={{ margin: '0 0 1rem 0', fontSize: '1.3rem' }}>
                    📅 {getMonthLabel(payslip.month)}
                  </h3>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1rem' }}>
                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '0.8rem', borderRadius: '8px' }}>
                      <div style={{ fontSize: '0.8rem', opacity: 0.8, marginBottom: '0.3rem' }}>Salaire Brut</div>
                      <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                        {parseFloat(payslip.gross_salary || 0).toFixed(2)}€
                      </div>
                    </div>

                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '0.8rem', borderRadius: '8px' }}>
                      <div style={{ fontSize: '0.8rem', opacity: 0.8, marginBottom: '0.3rem' }}>Heures</div>
                      <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                        {parseFloat(payslip.worked_hours || 0).toFixed(1)}h
                      </div>
                    </div>

                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '0.8rem', borderRadius: '8px' }}>
                      <div style={{ fontSize: '0.8rem', opacity: 0.8, marginBottom: '0.3rem' }}>Primes</div>
                      <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                        {parseFloat(payslip.bonus || 0).toFixed(2)}€
                      </div>
                    </div>

                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '0.8rem', borderRadius: '8px' }}>
                      <div style={{ fontSize: '0.8rem', opacity: 0.8, marginBottom: '0.3rem' }}>Cotisations</div>
                      <div style={{ fontSize: '1.3rem', fontWeight: 'bold' }}>
                        -{parseFloat(payslip.deductions || 0).toFixed(2)}€
                      </div>
                    </div>
                  </div>

                  <div style={{
                    background: 'rgba(255,255,255,0.25)',
                    padding: '1rem',
                    borderRadius: '8px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '0.9rem', opacity: 0.9, marginBottom: '0.3rem' }}>Salaire Net</div>
                    <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                      {parseFloat(payslip.net_salary || 0).toFixed(2)}€
                    </div>
                  </div>

                  <div style={{ fontSize: '0.8rem', opacity: 0.8, marginTop: '1rem', textAlign: 'center' }}>
                    Synchronisé le: {format(new Date(payslip.sync_date), 'dd/MM/yyyy')}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Modal détails bulletin */}
        {selectedPayslip && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.5)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000
            }}
            onClick={() => setSelectedPayslip(null)}
          >
            <div
              style={{
                background: 'white',
                padding: '2rem',
                borderRadius: '12px',
                maxWidth: '600px',
                width: '90%',
                maxHeight: '80vh',
                overflowY: 'auto'
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <h2 style={{ marginBottom: '1.5rem' }}>Bulletin de paie - {getMonthLabel(selectedPayslip.month)}</h2>

              <div style={{ background: '#f8f9fa', padding: '1.5rem', borderRadius: '8px', marginBottom: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem', paddingBottom: '0.8rem', borderBottom: '1px solid #ddd' }}>
                  <span style={{ fontWeight: 'bold' }}>Salaire Brut:</span>
                  <span style={{ fontSize: '1.1rem', fontWeight: 'bold' }}>
                    {parseFloat(selectedPayslip.gross_salary || 0).toFixed(2)}€
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem' }}>
                  <span>Heures travaillées:</span>
                  <span>{parseFloat(selectedPayslip.worked_hours || 0).toFixed(1)}h</span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem' }}>
                  <span>Primes:</span>
                  <span style={{ color: '#27ae60', fontWeight: 'bold' }}>
                    +{parseFloat(selectedPayslip.bonus || 0).toFixed(2)}€
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.8rem', paddingBottom: '0.8rem', borderBottom: '1px solid #ddd' }}>
                  <span>Cotisations:</span>
                  <span style={{ color: '#e74c3c', fontWeight: 'bold' }}>
                    -{parseFloat(selectedPayslip.deductions || 0).toFixed(2)}€
                  </span>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '0.8rem' }}>
                  <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>Salaire Net:</span>
                  <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#27ae60' }}>
                    {parseFloat(selectedPayslip.net_salary || 0).toFixed(2)}€
                  </span>
                </div>
              </div>

              <div style={{ fontSize: '0.85rem', color: '#666', textAlign: 'center', marginBottom: '1.5rem' }}>
                Synchronisé le {format(new Date(selectedPayslip.sync_date), 'dd/MM/yyyy à HH:mm')}
              </div>

              {selectedPayslip.file_path && (
                <a
                  href={`/uploads/payslips/${selectedPayslip.file_path}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'block',
                    textAlign: 'center',
                    padding: '0.8rem',
                    background: '#B8472E',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    marginBottom: '1rem'
                  }}
                >
                  📥 Télécharger le PDF
                </a>
              )}

              <button
                onClick={() => setSelectedPayslip(null)}
                style={{
                  width: '100%',
                  padding: '0.7rem',
                  background: '#95a5a6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  cursor: 'pointer'
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Payslips;
